import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function CodeCopy({ command = "pip install upii" }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(command);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = command;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div
      className="flex items-center justify-between gap-4 rounded-xl border border-white/10 bg-black/40 px-5 py-4 font-mono text-sm"
      data-testid="install-snippet"
    >
      <code className="truncate text-paper">
        <span className="text-ember">$</span> {command}
      </code>
      <button
        onClick={copy}
        className="flex shrink-0 items-center gap-1.5 rounded-md border border-white/10 px-3 py-1.5 text-xs text-mute transition-colors hover:border-ember/40 hover:text-paper"
        data-testid="install-copy-button"
      >
        {copied ? (
          <>
            <Check size={13} className="text-ember" /> Copied
          </>
        ) : (
          <>
            <Copy size={13} /> Copy
          </>
        )}
      </button>
    </div>
  );
}
